import { helperTypes } from '../constants';

const setPlatform = (isMobile, isIos) => ({
  type: helperTypes.SET_PLATFORM,
  isMobile,
  isIos
});

export const setCampaign = (campaign) => ({
  type: helperTypes.SET_CAMPAIGN,
  campaign
});

export default setPlatform;
